import Breakpoints from '../../_constants/breakpoints';
import { getCurrentBreakpoint } from '../../_modules/breakpoint/get_current_breakpoint';

const onScroll = (
    $window,
    $header,
    $main,
    $statusbar,
    $statusbarMobile,
    stickyStatusbarModifier,
    $container) => event => {
        let distanceScrolled = $window.scrollTop();
        const currentBreakpoint = getCurrentBreakpoint(window.innerWidth);
        const $currentStatusbar = currentBreakpoint < Breakpoints.SM ? $statusbarMobile : $statusbar;
        const header = Array.from($header);
        let headerHeight = 0;
        header.forEach(h => {
            headerHeight += h.offsetHeight;
        });

        if (distanceScrolled > headerHeight && !$container.hasClass(stickyStatusbarModifier)) {
            $container.addClass(stickyStatusbarModifier);
            $main.css('padding-top', $currentStatusbar.outerHeight());
            setCatalogContainerStyle($currentStatusbar.outerHeight());
        } else if (distanceScrolled <= headerHeight && $container.hasClass(stickyStatusbarModifier)) {
            $container.removeClass(stickyStatusbarModifier);
            $main.css('padding-top', '');
            setCatalogContainerStyle(0);
        }
    };

function setCatalogContainerStyle(value) {
  const catalogContainer = document.querySelector('.catalog-container');

  if (catalogContainer) {
    catalogContainer.style.cssText = `padding-top:${0}px !important;`;
  }
}

function handleStatusbarPosition($container) {
    const $window = $(window);
    const $header = $('.header, .sca-header, .kogan-header, .navigation, .above-header-info');
    const $main = $('.page-main');
    const $statusbar = $('.catalog-statusbar');
    const $statusbarMobile = $('.catalog-statusbar-mobile');
    const stickyStatusbarModifier = 'statusbar-sticky';
    const onScrollHandler = onScroll(
        $window,
        $header,
        $main,
        $statusbar,
        $statusbarMobile,
        stickyStatusbarModifier,
        $container
    );

    $window.on('scroll', onScrollHandler);
    onScrollHandler();
}

export { handleStatusbarPosition };
